import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { MenuIcon, PlusIcon, XIcon } from "lucide-react";
import { BracketButton } from "./BracketButton";
import { SaftiLogo } from "./SaftiLogo";
import { languages, navLinks } from "../data/content";
export function Header() {
  const [open, setOpen] = useState(false);
  const [lang, setLang] = useState("FR");
  return <header className="sticky top-0 z-40 border-b border-paper-line bg-paper/90 backdrop-blur" data-id="element-132" data-mp="2rmxf78g0x66v">
      <div className="mx-auto flex h-20 max-w-[1400px] items-center justify-between px-5 md:px-10" data-id="element-133" data-mp="2wkqmy5wz6899">
        <a href="#top" className="flex flex-col leading-none" aria-label="Accueil SAFTI Infiny Team" data-id="element-134" data-mp="31bp2326890ax">
          <SaftiLogo data-id="element-135" data-mp="36bbgvg1peolu" />
          <span className="mt-1 pl-[38px] text-[10px] font-medium uppercase tracking-[0.3em] text-ink-muted" data-id="element-136" data-mp="369qnhtr4lbpk">Infiny Team</span>
        </a>

        <nav aria-label="Navigation principale" className="hidden items-center gap-8 lg:flex" data-id="element-137" data-mp="3b8bovwi461fl">
          {navLinks.map(l => <a key={l.href} href={l.href} className="group flex items-center gap-1.5 text-[13px] font-medium uppercase tracking-[0.1em] text-ink transition-colors duration-150 hover:text-brand-deep" data-id="element-138" data-mp="2wl4fwrj6q8gq">
              <PlusIcon className="h-3 w-3 text-ink-faint transition-transform duration-200 ease-out group-hover:rotate-90" data-id="element-139" data-mp="2mord945nwk9u" />
              {l.label}
            </a>)}
        </nav>

        <div className="hidden items-center gap-6 lg:flex" data-id="element-140" data-mp="3fakl3s5tep3h">
          <ul className="flex items-center gap-1 text-[12px] text-ink-faint" aria-label="Langue" data-id="element-141" data-mp="3adajzf92cozt">
            {languages.map((l, i) => <li key={l} className="flex items-center gap-1" data-id="element-142" data-mp="35jg3slso2s5h" data-mpi={i}>
                <button onClick={() => setLang(l)} aria-pressed={lang === l} className={`px-1 transition-colors duration-150 ${lang === l ? "font-semibold text-brand-deep" : "hover:text-ink"}`} data-id="element-143" data-mp="30leng8mml6xp">
                  {l}
                </button>
                {i < languages.length - 1 && <span aria-hidden="true" data-id="element-144" data-mp="1rfxhei1sn66r">/</span>}
              </li>)}
          </ul>
          <BracketButton href="#contact" data-id="element-145" data-mp="1weqtq75cgr5c">Rejoindre l'équipe</BracketButton>
        </div>

        <button className="flex h-10 w-10 items-center justify-center lg:hidden" onClick={() => setOpen(o => !o)} aria-expanded={open} aria-label={open ? "Fermer le menu" : "Ouvrir le menu"} data-id="element-146" data-mp="1hni1dqa24roi">
          {open ? <XIcon className="h-6 w-6" data-id="element-147" data-mp="1coxaihgp3kcq" /> : <MenuIcon className="h-6 w-6" data-id="element-148" data-mp="1cq8eoie1yu4d" />}
        </button>
      </div>

      <AnimatePresence data-id="element-149" data-mp="ypp9rk4vw46f">
        {open && <motion.nav initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="border-t border-paper-line bg-paper px-5 pb-6 lg:hidden" aria-label="Navigation mobile" data-id="element-150" data-mp="yr0bzfiol3vf">
            {navLinks.map(l => <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="flex items-center justify-between border-b border-paper-line py-4 text-lg font-medium" data-id="element-151" data-mp="mexvirr8hkr4">
                {l.label}
                <PlusIcon className="h-4 w-4 text-ink-faint" data-id="element-152" data-mp="rczgji87zu58" />
              </a>)}
            <div className="mt-6" data-id="element-153" data-mp="153us52a3spci">
              <BracketButton href="#contact" data-id="element-154" data-mp="1578uiairoyjy">Rejoindre l'équipe</BracketButton>
            </div>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}